import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=fa04399a&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa04399a')) {
      api.createRecord('fa04399a', component.options)
    } else {
      api.reload('fa04399a', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=fa04399a&", function () {
      api.rerender('fa04399a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KloDoSH3Xtbk/JS/pricehelp.vue"
export default component.exports